import request from '@/utils/request'

// 查询技术成果管理列表
export function listTechnological(query) {
  return request({
    url: '/business/technological/list',
    method: 'get',
    params: query
  })
}
// 查询技术成果管理列表-不分页
export function listTechnologicalAll(query) {
  return request({
    url: '/business/technological/listAll',
    method: 'get',
    params: query
  })
}
// 查询技术成果管理详细
export function getTechnological(id) {
  return request({
    url: '/business/technological/' + id,
    method: 'get'
  })
}

// 新增技术成果管理
export function addTechnological(data) {
  return request({
    url: '/business/technological',
    method: 'post',
    data: data
  })
}

// 修改技术成果管理
export function updateTechnological(data) {
  return request({
    url: '/business/technological',
    method: 'put',
    data: data
  })
}

// 删除技术成果管理
export function delTechnological(id) {
  return request({
    url: '/business/technological/' + id,
    method: 'delete'
  })
}

// 置顶
export function setTop(id) {
  return request({
    url: '/business/technological/setTop/' + id,
    method: 'get'
  })
}


// 取消置顶
export function cancelTop(id) {
  return request({
    url: '/business/technological/cancelTop/' + id,
    method: 'get',
  })
}
